// AI gateway client - one call powers the assistant, per-page analyze, and support.

import { supabase } from '@govern360/shared';

export async function askAI({ question, context = '', mode = 'assistant' }) {
  const { data: { session } } = await supabase.auth.getSession();
  const r = await fetch('/.netlify/functions/ai-gateway', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${session?.access_token || ''}` },
    body: JSON.stringify({ question, context, mode }),
  });
  const j = await r.json().catch(() => ({}));
  if (!r.ok) return { error: j.error || 'AI request failed' };
  return { answer: j.answer, summary: j.summary, needsProvider: j.needsProvider, provider: j.provider };
}

// Structured executive summary for the rich card UI. Returns
// { summary, answer, needsProvider, error }. `summary` is the parsed object
// (grade, headline, top_findings, do_this_first, sections, boardroom_line) or
// null - in which case the caller renders `answer` as prose.
export async function execSummary({ question, context = '' }) {
  return askAI({ question, context, mode: 'exec_summary' });
}
